import { SUGGESTED_SERIES_ASPECT_CLASS } from 'src/constants/suggested-series'
import React from 'react'

export type SuggestedSeriesLoadingNextOverlayProps = {
  secondsRemaining: number
}

export const SuggestedSeriesLoadingNextOverlay = ({
  secondsRemaining,
}: SuggestedSeriesLoadingNextOverlayProps): React.ReactElement => {
  return (
    <div
      className={`relative w-full ${SUGGESTED_SERIES_ASPECT_CLASS} rounded-md overflow-hidden shadow-lg bg-black border border-neutral-800 flex flex-col items-center justify-center px-6 py-10 animate-in fade-in zoom-in-[0.98] duration-300`}
      data-testid="suggested-series-loading-next-overlay"
    >
      <div className="text-center space-y-3 max-w-xl">
        <div className="font-evogria text-ivory uppercase text-lg md:text-3xl leading-tight tracking-wide">
          Suggested series removed,
          <span role="status" aria-live="polite" aria-atomic="true">
            <span className="text-ivory font-evogria uppercase text-lg md:text-3xl leading-tight tracking-wide">
              Loading next one:{' '}
            </span>
            <span className="text-mushroom font-evogria uppercase text-lg md:text-3xl leading-tight tracking-wide">
              {secondsRemaining} sec
            </span>
          </span>
        </div>
      </div>
    </div>
  )
}
